import type { Resource, ResourceSection } from '../../../mocks/localResources';

interface ResourceCardProps {
  resource: Resource;
  section: ResourceSection;
}

export default function ResourceCard({ resource, section }: ResourceCardProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-6 flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h4 className="text-base font-bold text-gray-900 leading-snug">{resource.name}</h4>
        <span className="inline-flex items-center gap-1 text-xs text-gray-400 font-medium">
          <i className="ri-map-pin-line text-xs"></i>
          {resource.city}
        </span>
      </div>

      <p className="text-sm text-gray-500 leading-relaxed flex-1">{resource.description}</p>

      {resource.website && (
        <a
          href={resource.website}
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center justify-center gap-1.5 text-sm font-semibold px-4 py-2.5 rounded-lg border-2 ${section.buttonBorder} ${section.buttonText} hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap`}
        >
          Visit Website
          <i className="ri-arrow-right-up-line text-sm"></i>
        </a>
      )}
      {!resource.website && resource.phone && (
        <a
          href={`tel:${resource.phone.replace(/\D/g, '')}`}
          className={`inline-flex items-center justify-center gap-1.5 text-sm font-semibold px-4 py-2.5 rounded-lg border-2 ${section.buttonBorder} ${section.buttonText} hover:opacity-80 transition-opacity cursor-pointer whitespace-nowrap`}
        >
          <i className="ri-phone-line text-sm"></i>
          {resource.phone}
        </a>
      )}
    </div>
  );
}
